import React from "react";

export default function Background({ children }) {
  return (
    <div className="auth-bg bg-cover bg-no-repeat bg-[url('/src/images/bg.png')] relative">
      {children}
    </div>
  );
}
